import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function Merch() {
  return (
    <div data-testid="merch-page" className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center">
        <div className="eyebrow mb-3">Team Shop</div>
        <h1 className="font-display text-5xl sm:text-6xl uppercase font-bold tracking-tight">Kraken Gear</h1>
        <div className="kr-card rounded-2xl p-16 mt-12 max-w-2xl mx-auto">
          <div className="font-display text-4xl sm:text-5xl uppercase text-[#00E5FF]">Coming Soon</div>
          <p className="text-slate-400 mt-4">Hats, shirts, hoodies, jerseys, and custom Kraken gear are on the way.</p>
        </div>
      </div>
    </div>
  );
}
